import api from '@api'; // Instead of ../../../utils/api
import React, { useState, useEffect } from 'react';
import { useParams, NavLink, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './LeagueAuth.css';
import LeagueGameAuth from '../../Game/Auth/LeagueGameAuth';
import GameInLeagueAuth from './GameInLeagueAuth';
import Breadcrumbs from '../../../components/Breadcrumbs';

function LeagueAuth() {
  const { isAuthenticated, loading, user } = useAuth(); // ✅ Add auth state
  const [league, setLeague] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [teamForm, setTeamForm] = useState({ name: '', copyFromTeamId: '' });
  const [teams, setTeams] = useState([]);
  const [teamSearch, setTeamSearch] = useState('');
  const [allPlayers, setAllPlayers] = useState([]);
  const [captainSearch, setCaptainSearch] = useState('');


  // const { id } = useParams();
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [seasonId, setSeasonId] = useState(null);
  const { seasons_id: season_id, id: leagueId } = useParams();
  const [seasonTeams, setSeasonTeams] = useState([]);
  const [updateForm, setUpdateForm] = useState({
    id: null,
    name: '',
    captain: '',
    captainId: '',
  });


  useEffect(() => {
    const fetchAllSeasonTeams = async () => {
      if (!seasonId || !isModalOpen) return;

      try {
        const res = await api.get(`/api/teamsv2`);
        setSeasonTeams(res.data.teams || []);
      } catch (err) {
        console.error("Error fetching all season teams:", err);
      }
    };

    fetchAllSeasonTeams();
  }, [seasonId, isModalOpen]);




  useEffect(() => {
    const fetchSeasonIdFromSeasonLeagues = async () => {
      if (!leagueId) return;
      try {
        const res = await api.get(`/api/seasonsleagues`, {
          withCredentials: true
        });
        const entry = res.data.seasonsLeagues.find(
          (item) => item.league.id === Number(leagueId) && item.season
        );
        if (entry) {
          setSeasonId(entry.season.id);
          setLeague(entry.league)
        }
      } catch (err) {
        console.error("Error fetching seasonsLeagues:", err);
      }
    };
    fetchSeasonIdFromSeasonLeagues();
  }, [leagueId]);



  // useEffect(() => {
  // }, [teams]);

  // useEffect(() => {
  //   const fetchTeamsInLeague = async () => {
  //     if (!seasonId || !id) return;

  //     try {
  //       const res = await api.get(`/api/seasonsv2/${seasonId}/leagues/${id}/teams`);
  //       setTeams(res.data.teams || []);
  //       console.log(teams)
  //     } catch (err) {
  //       console.error("Error fetching teams for season-league:", err);
  //     }
  //   };

  //   fetchTeamsInLeague();
  // }, [seasonId, id]);

  // useEffect(() => {
  //   const fetchAllPlayers = async () => {
  //     try {
  //       const res = await api.get('/api/playersv2', { withCredentials: true });
  //       setAllPlayers(res.data.players || []);
  //       console.log(res.data.players)
  //     } catch (err) {
  //       console.error("Error fetching all players:", err);
  //     }
  //   };
  //   if (isAuthenticated) fetchAllPlayers();
  // }, [isAuthenticated]);

  // // Create Team
  // const handleCreateTeam = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const responses = await Promise.all(
  //       teamNames
  //         .filter(name => name.trim())
  //         .map(name =>
  //           api.post(`/api/leagues/${id}/teams`, { name }, { withCredentials: true })
  //         )
  //     );

  //     const newTeams = responses.map(res => ({ ...res.data.team, players: [] }));

  //     setTeams(prev => [...prev, ...newTeams]);
  //     setLeagueInfo(prev => ({
  //       ...prev,
  //       teams: [...(prev?.teams || []), ...newTeams],
  //     }));

  //     setTeamNames([""]);
  //     setIsModalOpen(false);
  //     setMessage("Teams created successfully");
  //     setTimeout(() => setMessage(""), 3000);
  //   } catch (error) {
  //     console.error("Error creating teams:", error);
  //     setMessage("Error creating one or more teams");
  //     setTimeout(() => setMessage(""), 3000);
  //   }
  // };
  const handleCreateTeam = async (e) => {
    e.preventDefault();
    if (!seasonId || !leagueId) return;

    if (!teamForm.name && !teamForm.copyFromTeamId) {
      setMessage("Please enter a team name or select an existing team.");
      return;
    }

    try {
      const payload = {};

      if (teamForm.copyFromTeamId) {
        payload.copyFromTeamId = teamForm.copyFromTeamId;
      } else {
        payload.name = teamForm.name.trim();
      };
      console.log(payload)
      const res = await api.post(
        `/api/seasonsv2/${seasonId}/leagues/${leagueId}/teams`,
        payload,
        { withCredentials: true }
      );

      const res2 = await api.get(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/teams`);
      setTeams(res2.data.teams || []);

      setIsModalOpen(false);
      setTeamForm({ name: "", copyFromTeamId: "" });
      setMessage("Team added successfully");
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Error creating team:", err);
      setMessage("Failed to add team");
    }
  };



  useEffect(() => {
    const fetchTeamsInLeague = async () => {
      if (!seasonId || !leagueId) return;
      const res = await api.get(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/teams`);
      setTeams(res.data.teams || []);
    };
    fetchTeamsInLeague();
  }, [seasonId, leagueId]);



  // // Update Team
  const handleUpdateTeam = async (e) => {
    e.preventDefault();
    try {
      const res = await api.put(
        `/api/seasonsv2/${seasonId}/leagues/${leagueId}/teams/${updateForm.id}`,
        {
          name: updateForm.name,
          captain:
            updateForm.captainId
              ? (() => {
                const player = allPlayers.find(p => p.id === Number(updateForm.captainId));
                return player ? `${player.firstName} ${player.lastName}` : '';
              })()
              : updateForm.captain || null,
          captainId: updateForm.captainId || null,
        },
        { withCredentials: true }
      );
      const { captain, captainId } = updateForm;
      console.log(captain);
      console.log(captainId);

      // Replace the updated team in the teams list
      setTeams((prev) =>
        prev.map((t) => (t.id === updateForm.id ? res.data.team : t))
      );

      setMessage("Team updated!");
      setIsUpdateModalOpen(false);
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Error updating team:", err);
      setMessage("Failed to update team");
    }
  };


  // // Open Update Modal
  const openUpdateModal = async (team) => {
    try {
      // ✅ Only fetch players when needed
      const res = await api.get(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/teams/${team.id}/players`, {
        withCredentials: true,
      });

      setAllPlayers(res.data.players || []);
    } catch (err) {
      console.error("Error fetching players for team:", err);
    }

    setUpdateForm({
      id: team.id,
      name: team.name || '',
      captain: team.captain || '',
      captainId: team.captain_id || '',
    });

    setIsUpdateModalOpen(true);
  };



  const handleDeleteTeams = async () => {
    if (!selectedTeams.length) return alert("Please select at least one team.");
    if (!window.confirm("Delete selected teams?")) return;

    try {
      await Promise.all(
        selectedTeams.map(id =>
          api.delete(`/api/seasonsv2/${seasonId}/leagues/${leagueId}/teams/${id}`, {
            withCredentials: true
          })
        )
      );
      setTeams(prev => prev.filter(team => !selectedTeams.includes(team.id)));
      setSelectedTeams([]);
      setMessage("Teams deleted successfully");
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Error deleting teams:", err);
    }
  };



  // Handle Checkbox
  const handleCheckboxChange = (id) => {
    setSelectedTeams(prevSelected =>
      prevSelected.includes(id) ? prevSelected.filter(item => item !== id) : [...prevSelected, id]
    );
  };

  // Handle select all leagues
  const handleSelectAll = () => {
    if (selectedTeams.length === teams.length) {
      setSelectedTeams([]); // Unselect all if already selected
    } else {
      setSelectedTeams(teams.map(team => team.id)); // Select all teams
    }
  };

  // if (loading) return <p>Loading team...</p>;
  // if (error) return <p>{error}</p>;



  // const sortedTeams = [...teams].sort((a, b) => {
  //   if (a.wins !== b.wins) {
  //     return b.wins - a.wins; // Sort by most wixns first
  //   }
  //   return a.losses - b.losses; // If wins are tied, sort by fewest losses
  // });

  // // Assign proper ranking with correct sequential numbering
  // let rank = 1;
  // let lastRank = 1;
  // const rankedTeams = sortedTeams.map((team, index, arr) => {
  //   if (index > 0 && team.wins === arr[index - 1].wins && team.losses === arr[index - 1].losses) {
  //     return { ...team, rank: lastRank }; // Assign same rank as previous if tied
  //   }
  //   lastRank = rank; // Store the last assigned rank
  //   return { ...team, rank: rank++ }; // Increment rank properly
  // });

  // // Apply pagination after ranking
  // const indexOfLastLeague = currentPage * leaguesPerPage;
  // const indexOfFirstLeague = indexOfLastLeague - leaguesPerPage;
  // const currentLeagues = rankedTeams.slice(indexOfFirstLeague, indexOfLastLeague);



  console.log()

  return (
    <div className="league_auth">
      <Breadcrumbs />
      <div>
        {/* <h2 className="league_auth_title">{league?.name}</h2> */}
      </div>
      <div className="leagueAuth-team-container">
        <div className="leagueAuth-btn-container">
          <button className="delete-leagueAuth-btn" onClick={handleDeleteTeams} disabled={!selectedTeams.length}>
            🗑️
          </button>

          <button className="add-leagueAuth-btn" onClick={() => {
            setTeamForm({ name: '', copyFromTeamId: '' });
            setIsModalOpen(true);
          }}>
            + Add Team
          </button>
        </div>

        <table className="leagueAuthTeam-table">
          <thead>
            <tr>
              <th><input type="checkbox" checked={selectedTeams.length === teams.length} onChange={handleSelectAll} /></th>
              <th>Standings</th>
              <th>Teams</th>
              <th>Captain</th>
              <th>Players</th>
              <th>Wins</th>
              <th>Losses</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {teams.length === 0 ? (
              <tr><td colSpan="8" className="no_team">No teams available</td></tr>
            ) : (
              teams
                .sort((a, b) => a.rank - b.rank) // just in case, enforce correct order
                .map((team) => (
                  <tr key={team.id}>
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedTeams.includes(team.id)}
                        onChange={() => handleCheckboxChange(team.id)}
                      />
                    </td>
                    <td>{team.rank || '-'}</td>
                    <td>
                      {team.playersCount < 5 && (
                        <span className="warning-tooltip">
                          ⚠️
                          <span className="tooltip-text">Team has fewer than 5 players</span>
                        </span>
                      )}
                      <NavLink to={`/dashboard/seasons/${seasonId}/leagues/${leagueId}/teams/${team.id}`}>
                        {team.name}
                      </NavLink>
                    </td>

                    <td>{team.captain}</td>
                    <td>{team.playersCount || 0}</td>
                    <td>{team.wins}</td>
                    <td>{team.losses}</td>
                    <td>
                      <button onClick={() => openUpdateModal(team)}>✏️</button>

                    </td>
                  </tr>
                ))
            )}
          </tbody>

        </table>
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <form onSubmit={handleCreateTeam}>
                {/* <label>Create a new team:</label> */}
                {/* 🔍 Team Search Input */}
                <input
                  type="text"
                  value={teamSearch}
                  onChange={(e) => {
                    setTeamSearch(e.target.value);
                    setTeamForm({ ...teamForm, copyFromTeamId: "", name: e.target.value }); // update name if typing
                  }}
                  placeholder="Enter new team name or search..."
                />

                {/* 🔍 Autocomplete Results */}
                {teamSearch && (
                  <div className="search-results-dropdown">
                    {seasonTeams
                      .filter((team) =>
                        team.name.toLowerCase().includes(teamSearch.toLowerCase())
                      )
                      .slice(0, 10)
                      .map((team) => (
                        <div
                          key={team.id}
                          className="search-result-item"
                          onClick={() => {
                            setTeamForm({
                              ...teamForm,
                              copyFromTeamId: team.id,
                              name: team.name,
                            });
                            setTeamSearch(team.name); // update visible input
                          }}
                        >
                          {team.name}
                        </div>
                      ))}
                  </div>
                )}

                {/* 🔽 Traditional Fallback Dropdown */}
                <select
                  value={teamForm.copyFromTeamId || ""}
                  onChange={(e) =>
                    setTeamForm({
                      ...teamForm,
                      copyFromTeamId: e.target.value,
                      name: "", // Clear name input if selecting from dropdown
                    })
                  }
                >
                  <option value="">-- Or Select from List --</option>
                  {seasonTeams.map((team, index) => (
                    <option key={`${team.id}-${index}`} value={team.id}>
                      {team.name}
                    </option>
                  ))}
                </select>


                <div className="modal-btn-row">
                  {/* <button type="button" onClick={() => setTeamNames([...teamNames, ""])}>+ Add More</button>
                  <button type="button" onClick={() => setTeamNames(teamNames.slice(0, -1))}>- Remove Last</button> */}
                  <button type="submit">Submit</button>
                  <button type="button" onClick={() => setIsModalOpen(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Update League Modal */}
        {isUpdateModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <form onSubmit={handleUpdateTeam}>
                <label className="update-team-label">
                  Team Name:
                  <input
                    type="text"
                    value={updateForm.name}
                    onChange={(e) => setUpdateForm({ ...updateForm, name: e.target.value })}
                  />
                </label>

                {/* <label>
                  Captain Name (manual):
                  <input
                    type="text"
                    value={updateForm.captain}
                    onChange={(e) => setUpdateForm({ ...updateForm, captain: e.target.value, captainId: '' })}
                    placeholder="e.g. Coach Mike"
                  />
                </label> */}

                <label className="update-team-label">
                  Select Existing Player (Captain):

                  {/* 🔍 Search Box */}
                  <input
                    type="text"
                    placeholder="Search player..."
                    value={captainSearch}
                    onChange={(e) => {
                      setCaptainSearch(e.target.value);
                      setUpdateForm(prev => ({ ...prev, captainId: '', captain: '' }));
                    }}
                    className="captain-search-input"
                  />

                  {/* 🔍 Search Dropdown */}
                  {captainSearch && (
                    <div className="search-results-dropdown">
                      {allPlayers
                        .filter(p =>
                          `${p.firstName} ${p.lastName}`.toLowerCase().includes(captainSearch.toLowerCase())
                        )
                        .slice(0, 10)
                        .map((p) => {
                          const teamNames = [...new Set(
                            p.rosters?.map((r) => r.team?.name).filter(Boolean)
                          )].join(", ");
                          return (
                            <div
                              key={p.id}
                              className="search-result-item"
                              onClick={() => {
                                setUpdateForm(prev => ({
                                  ...prev,
                                  captainId: p.id,
                                  captain: `${p.firstName} ${p.lastName}`,
                                }));
                                setCaptainSearch(`${p.firstName} ${p.lastName}`);
                              }}
                            >
                              {p.firstName} {p.lastName} {teamNames ? `(${teamNames})` : ""}
                            </div>
                          );
                        })}
                    </div>
                  )}

                  {/* 🔽 Fallback Select Dropdown */}
                  <select
                    value={updateForm.captainId}
                    onChange={(e) => {
                      const selected = allPlayers.find(p => p.id === parseInt(e.target.value));
                      setUpdateForm({
                        ...updateForm,
                        captainId: selected?.id || '',
                        captain: selected ? `${selected.firstName} ${selected.lastName}` : '',
                      });
                      setCaptainSearch('');
                    }}
                  >
                    <option value="">-- Or Select from List --</option>
                    {[...allPlayers]
                      .sort((a, b) => a.firstName.localeCompare(b.firstName))
                      .map((p) => {
                        const teamNames = [...new Set(
                          p.rosters?.map((r) => r.team?.name).filter(Boolean)
                        )].join(", ");
                        return (
                          <option key={p.id} value={p.id}>
                            {p.firstName} {p.lastName}{teamNames ? ` (${teamNames})` : ""}
                          </option>
                        );
                      })}
                  </select>
                </label>





                <div className="modal-btn-row">
                  <button type="submit">Update</button>
                  <button type="button" onClick={() => setIsUpdateModalOpen(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>

        )}
      </div>
      <GameInLeagueAuth leagueId={leagueId} seasonId={seasonId} teams={teams} />
    </div>
  );
}


//   <div className="league_auth">
//     <div>
//       <h2 className="league_auth_title">{leagueInfo?.name}</h2>
//     </div>
//     <div className="leagueAuth-team-container">
//       <div className="leagueAuth-btn-container">
//         <button className="delete-leagueAuth-btn" onClick={handleDeleteTeams}>🗑️</button>
//         <button
//           className="add-leagueAuth-btn"
//           onClick={() => {
//             setTeamNames([""]); // Always start with one input
//             setIsModalOpen(true);
//           }}> + Add Team </button>
//       </div>
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <h3>Create Team</h3>
//           <form onSubmit={(e) => handleCreateTeam(e)}>
//               {teamNames.map((name, index) => (
//                 <input
//                   key={index}
//                   type="text"
//                   value={name}
//                   onChange={(e) => {
//                     const updated = [...teamNames];
//                     updated[index] = e.target.value;
//                     setTeamNames(updated);
//                   }}
//                   placeholder={`Team ${index + 1}`}
//                   required
//                 />
//               ))}
//               <div className="modal-btn-row">
//                 <button type="button" onClick={() => setTeamNames([...teamNames, ""])}>+ Add More</button>
//                 <button type="button" onClick={() => setTeamNames(teamNames.slice(0, -1))}>- Remove Last</button>
//                 <button type="submit">Submit</button>
//                 <button type="button" onClick={() => setIsModalOpen(false)}>Cancel</button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//      
//       {message && <p>{message}</p>}

//       <table className="leagueAuthTeam-table">
//         <thead>
//           <tr>
//             <th>
//               <input
//                 type="checkbox"
//                 checked={selectedTeams.length === teams.length}
//                 onChange={handleSelectAll}
//               />
//             </th>
//             <th>Standings</th>
//             <th>Teams</th>
//             <th>Captain</th>
//             <th>Players</th>
//             <th>Wins</th>
//             <th>Losses</th>
//             <th></th>
//           </tr>
//         </thead>
//         <tbody>
//           {teams.length === 0 ? (
//             <tr><td colSpan="5" className="no_team">No teams available</td></tr>
//           ) : (
//             currentLeagues.map((team) => (
//               <tr key={team.id} >
//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={selectedTeams.includes(team.id)}
//                     onChange={() => handleCheckboxChange(team.id)}
//                   />
//                 </td>
//                 <td>{team.rank}</td>
//                 <td>
//                   {team.players?.length < 5 && (
//                     <span className="warning-tooltip">
//                       ⚠️
//                       <span className="tooltip-text">Team has fewer than 5 players</span>
//                     </span>
//                   )}
//                   <NavLink to={`/dashboard/singleTeamToggle/${team.id}`}>
//                     {team.name}
//                   </NavLink>
//                 </td>
//                 <td>{team.captain ? `${team.captain.firstName} ${team.captain.lastName}` : '-'}</td>
//                 <td>{team.players?.length}</td>
//                 <td>{team.wins}</td>
//                 <td>{team.losses}</td>
//                 <td>
//                   <button className="leagueAuthTeam-update-btn" onClick={() => openUpdateModal(team)}>
//                     <span>🖊</span> EDIT
//                   </button>
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//       {/* <div className="pagination">
//         <div>
//           <button
//             className="pagination-btn"
//             onClick={() => setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//           >
//             ◀
//           </button>
//           <span> Page {currentPage} </span>
//           <button
//             className="pagination-btn"
//             onClick={() => setCurrentPage(currentPage + 1)}
//             disabled={indexOfLastLeague >= teams.length}
//           >
//             ▶
//           </button>
//         </div>
//         <div>
//           <select
//             value={leaguesPerPage}
//             onChange={(e) => setLeaguesPerPage(Number(e.target.value))}
//           >
//             <option value="30">Show 30</option>
//             <option value="10">Show 10</option>
//             <option value="50">Show 50</option>
//           </select>
//         </div>
//       </div> */}

//       </div>
//       <>
//         <div className="show-team-list-table">
//         </div>
//         <div className="league-game-container">
//           {/* <LeagueGameAuth leagueInfo={leagueInfo} /> */}
//         </div>
//       </>
//     </div>
//   );
// };

export default LeagueAuth;

